import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {TdoEnterpriseConfigurationModel} from '../../../models/configuration/tdo-enterprise-configuration.model';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseConfigurationService {
  tdoDomain = '';

  constructor(private http: HttpClient) {
    this.tdoDomain = window.location.hostname;
  }

  saveEnterprise(enterprise: TdoEnterpriseConfigurationModel): Observable<TdoEnterpriseConfigurationModel> {
    return this.http.post<TdoEnterpriseConfigurationModel>('/api/enterprise-configuration/save-enterprise/', enterprise);
  }

  getEnterpriseOrganizations(enterpriseId: string): Observable<OrganizationDataModel[]> {
    return this.http.get<OrganizationDataModel[]>(`/api/enterprise-configuration/get-enterprise-organizations/${enterpriseId}`);
  }
}
